module.exports = __webpack_public_path__ + "static/img/7.096d1a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/7.png
// module id = qR9t
// module chunks = 0